module.exports = __webpack_public_path__ + "static/img/s3.9d7c1231.png";